import React, {ReactElement, useCallback, useState} from 'react';

import {GameScore} from '../../query/graphql';
import {useAppDispatch} from '../../store';
import {Actions} from '../gameSlice';
import LeaderboardAdd from './LeaderboardAdd';
import LeaderboardList from './LeaderboardList';

type Props = {
  addScore?: boolean;
  onClose: () => void;
};

const Leaderboard = ({addScore = false, onClose}: Props): ReactElement | null => {
  const dispatch = useAppDispatch();
  const [myScore, setMyScore] = useState<GameScore>();
  const [initialEntries, setInitialEntries] = useState<GameScore[]>();

  const handleEntrySubmitted = useCallback((myScore: GameScore, scores: GameScore[]) => {
    setMyScore(myScore);
    setInitialEntries(scores);
  }, []);

  const handlePlayAgain = useCallback(() => {
    dispatch(Actions.restart());
    onClose();
  }, [dispatch, onClose]);

  if (!addScore || myScore) {
    return (
      <LeaderboardList
        myScore={myScore}
        initialEntries={initialEntries}
        onClose={onClose}
        onPlayAgain={handlePlayAgain}
      />
    );
  } else {
    return <LeaderboardAdd onSubmitted={handleEntrySubmitted} />;
  }
};

export default Leaderboard;
